<template>
    <div class="tsa-agreementDialog" v-show="show" @touchmove.prevent>
        <div class="mask"></div>
        <div class="center">
            <div class="close">
                <span class="el-icon-close" @click="close"></span>
            </div>
            <div class="title" v-if="title">{{ title }}</div>
            <div class="content">
                <slot></slot>
                <div class="fill"></div>
            </div>
            <div class="btnGroup">
                <template v-if="type=='confirm'">
                    <div class="button cancel" @click="cancel">
                        <p>取消</p>
                    </div>
                    <div class="button confirm" @click="agree">
                        <p>确认</p>
                    </div>
                </template>
                <template v-else>
                    <div class="button cancel" @click="cancel">
                        <p>返回</p>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type:{
            type: String,
            default: 'confirm'
        },
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        }
    },
    watch: {
        value (val) {
            this.show = val
        }
    },
    data () {
        return {
            show: false,
        }
    },
    created(){
        // alert(this.value)
    },
    methods: {
        close () {
            this.cancel()
        },
        cancel () {
            this.$emit('input', false)
            this.$emit('on-cancel')
        },
        agree () {
            this.$emit('on-agree')
        },
    }
}
</script>

<style lang="scss" scoped>
    @media screen and (min-width:1101px) {
        @import './css/pc.scss';
    }
    @media screen and (max-width:1100px) {
        @import './css/mobile.scss';
    }
    @media screen and (max-width: 567px) {
        .tsa-agreementDialog {
            .center {
                width: 87.2%;
            }
        }
    }
</style>